export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AlertBanner.vue?vue&type=template&id=4cb7606e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AlertBanner.vue?vue&type=template&id=4cb7606e&scoped=true
// module id = 170
// module chunks = 0